// Application entry point. esbuild bundles this file (and everything it
// imports) into dist/js/main.js.
//
// Add feature modules under components/ and shared helpers under utils/,
// then import them here, e.g.:
//   import { initNav } from './components/nav.js';
//   import { qs } from './utils/dom.js';

import { initNavToggle } from './components/nav-toggle.js';
import { initNavSubmenus } from './components/nav-submenu.js';
import { initBrandsCarousel } from './components/brands-carousel.js';
import { initSlideTimers } from './components/slide-timer.js';
import { initCountUp } from './components/count-up.js';
import { initGalleryLightbox } from './components/gallery-lightbox.js';

function init() {
  initNavToggle();
  initNavSubmenus();
  initBrandsCarousel();
  initSlideTimers();
  initCountUp();
  initGalleryLightbox();
}

document.addEventListener('DOMContentLoaded', init);
